import { PriorityTiny } from '../../entities/job/priority.tiny';
import { Address, Entity, JobType, SystemWorkOrderStatus, ContactSummary } from '../../index';
import { EntityLink, JobPolicyThresholds, Site, SiteTiny } from '../../entities';

export interface JobPatchRequest {
    jobId: string;
    workOrderId: string;
    name?: string;
    status?: SystemWorkOrderStatus;
    priority?: PriorityTiny;
    dueDate?: Date;
    startDate?: Date;
    contact?: ContactSummary;
    description?: string;
    technician?: Entity;
    type?: JobType;
    customerPO?: string;
    customerWO?: string;
    owner?: ContactSummary;
    supervisor?: ContactSummary;
    jobDueDate?: Date;
    jobStartDate?: Date;
    siteAddress?: Address;
    pricebook?: Entity;
    completedDate?: Date;
    completedDatePrevious?: Date;
    finalisedDate?: Date;
    finalisedDatePrevious?: Date;
    updatedAt?: string;
}

export interface JobPatchField {
    priority?: PriorityTiny;
    contact?: ContactSummary;
    description?: string;
    type?: JobType;
    customerPO?: string;
    customerWO?: string;
    owner?: ContactSummary;
    fieldSupervisor?: ContactSummary;
    supervisor?: ContactSummary;
    site?: SiteTiny;
    pricebook?: Entity;
    labels?: Entity[];
    dueDate?: Date;
    startDate?: Date;
    customFields?: any;
    zones?: Entity[];
    links?: EntityLink[];
}

export enum JobUpdatedField {
    Contact = 'contact',
    Description = 'description',
    Priority = 'priority',
    Supervisor = 'supervisor',
    CustomerWO = 'customerWO',
    CustomerPO = 'customerPO',
    DueDate = 'dueDate',
    StartDate = 'startDate',
    Owner = 'owner',
    FieldSupervisor = 'fieldSupervisor',
    Pricebook = 'pricebook',
    Type = 'type',
    Labels = 'labels',
    Site = 'site',
    BillingCompany = 'billingCompany',
    Address = 'address',
    PlaceId = 'placeId',
    CustomFields = 'customFields',
    zones = 'zones',
    Claim = 'claim',
    DefectCount = 'defectCount',
    Links = 'links',
}

export const JobAllowUpdateFields = [
    'contact',
    'description',
    'priority',
    'supervisor',
    'customerWO',
    'customerPO',
    'dueDate',
    'startDate',
    'owner',
    'pricebook',
    'billingCompany',
    'type',
    'labels',
    'site',
    'address',
    'fieldSupervisor',
    'placeId',
    'customFields',
    'zones',
    'claim',
    'defectCount',
    'thresholds',
    'workorderDispatchTheme',
    'links',
    'policy',
    'integrationFields',
    'name',
];


// this is cool but can not use, just protect at compile time, run time we will die
// export type JobSafePatch = { [K in keyof Partial<JobPatchField>]: any };

export interface JobPipelinePatchRequest {
    jobId: string;
    updatedAt?: string;
    priority?: PriorityTiny;
    contact?: ContactSummary;
    description?: string;
    type?: JobType;
    customerPO?: string;
    customerWO?: string;
    owner?: ContactSummary;
    fieldSupervisor?: ContactSummary;
    supervisor?: ContactSummary;
    pricebook?: Entity;
    //Should only be set with pricebook, as it will only be used to override the default company of the pricebook
    billingCompanyOverride?: Entity;
    labels?: Entity[];
    dueDate?: Date;
    startDate?: Date;
    site?: Site;
    address?: Address;
    placeId?: string;
    zones?: Entity[];
    defectCount?: number;
    thresholds?: JobPolicyThresholds;
    customFields?: any;
    integrationFields?: any;
    links?: EntityLink[];

    /** to know what kind of action, currently it is used for "Update Pricing" */
    action?: 'Update Pricing';
}

export interface JobLabelAddedRequest {
    value: string;
    field: string;
    labelName: string;
    message?: string;
}
